import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';

const withAlert = (WrappedComponent: React.ComponentType<any>) => {
  return (props: any) => {
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
      if (message || error) {
        const timer = setTimeout(() => {
          setMessage('');
          setError('');
        }, 2000); // Clear the alert after 5 seconds

        return () => clearTimeout(timer); // Cleanup the timer on component unmount
      }
    }, [message, error]);

    return (
      <>
        {/* {message && <Alert variant='success'>{message}</Alert>}
        {error && <Alert variant='danger'>{error}</Alert>} */}
        <WrappedComponent
          {...props}
          error={error}
          setError={setError}
          message={message}
          setMessage={setMessage}
        />
      </>
    );
  };
};

export default withAlert;
